// src/admin/pages/AdminSignIn.jsx
import React, { useState } from "react";
import { supabase } from "../../supabaseClient";
import logoMark from "../../logo.png";
import "../styles/admin.css";

export default function AdminSignIn() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  async function onSubmit(e) {
    e.preventDefault();
    setError(null);
    setBusy(true);

    const { error } = await supabase.auth.signInWithPassword({
      email: email.trim(),
      password,
    });

    setBusy(false);
    if (error) setError(error.message);
  }

  return (
    <div className="adminAuth">
      <div className="adminAuth__card">
        <div className="adminAuth__brand adminAuth__brand--stack">
  <div className="adminAuth__logoWrap">
    <img className="adminAuth__logoImg" src={logoMark} alt="Try Play Go" />
  </div>

  <h1 className="adminAuth__title">Admin Sign In</h1>
  <p className="adminAuth__subtitle">Try Play Go - Dashboard</p>
</div>

        <form className="adminAuth__form" onSubmit={onSubmit}>
          <div className="adminAuth__field">
            <label>Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@tryplaygo.ca"
              required
            />
          </div>

          <div className="adminAuth__field">
            <label>Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              required
            />
          </div>

          {error && <div className="adminAuth__error">{error}</div>}

          <button type="submit" className="adminAuth__btn" disabled={busy}>
            {busy ? "Signing in…" : "Sign In"}
          </button>
        </form>

        <div className="adminAuth__footer">Internal use only • Try Play Go</div>
      </div>
    </div>
  );
}